import React, { useContext } from 'react';
import { UserContext } from '../../contexts/UserProvider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import Chip from '@mui/material/Chip';

export const GroupCard = ({ groupName, members, onClick }) => {
    const { userData } = useContext(UserContext);

    return (
        <Card sx={{ minWidth: 275, marginBottom: 2 }}>
            <CardActionArea onClick={onClick}>
                <CardContent>
                    <Typography variant="h6" component="div">
                        {groupName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ marginTop: 1 }}>
                        {members.map((member, index) => (
                            <Chip 
                                key={index} 
                                label={member.userId === userData.userId ? "You" : member.displayName} 
                                sx={{ marginRight: 0.5, marginTop: 0.5 }} 
                            />
                        ))}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};
